// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "rescript/lib/es6/curry.js";
import * as React from "react";
import * as DndKit from "./DndKit";
import * as Belt_Option from "rescript/lib/es6/belt_Option.js";
import * as Caml_option from "rescript/lib/es6/caml_option.js";

function arrayMove(prim0, prim1, prim2) {
  return DndKit.arrayMove(prim0, prim1, prim2);
}

function Make(S) {
  var make = DndKit.WrappedDndContext;
  var Provider = {
    make: make
  };
  var useDndMonitor = function (prim) {
    DndKit.wrappedUseDndMonitor(prim);
  };
  var useDndContext = function (prim) {
    return DndKit.wrappedUseDndContext();
  };
  var Js_Private = {
    Provider: Provider,
    useDndMonitor: useDndMonitor,
    useDndContext: useDndContext
  };
  var convertActiveEvent = function (ev) {
    return ev.data.current.t;
  };
  var convertOverEvent = function ($$event) {
    return Belt_Option.map(Caml_option.nullable_to_opt($$event.over), (function (over) {
                  return over.data.current.t;
                }));
  };
  var convertStartDragEvent = function ($$event) {
    return {
            active: $$event.active.data.current.t
          };
  };
  var convertDragEvent = function ($$event) {
    return {
            active: $$event.active.data.current.t,
            over: convertOverEvent($$event)
          };
  };
  var makeEventCallback = function (cb) {
    if (cb !== undefined) {
      return (function ($$event) {
                Curry._1(cb, convertDragEvent($$event));
              });
    }
    
  };
  var makeStartCallback = function (onDragStart) {
    if (onDragStart !== undefined) {
      return (function ($$event) {
                Curry._1(onDragStart, {
                      active: $$event.active.data.current.t
                    });
              });
    }
    
  };
  var useDndMonitor$1 = function (onDragStart, onDragOver, onDragEnd, onDragCancel, param) {
    var prim_onDragStart = makeStartCallback(onDragStart);
    var prim_onDragOver = makeEventCallback(onDragOver);
    var prim_onDragEnd = makeEventCallback(onDragEnd);
    var prim_onDragCancel = makeEventCallback(onDragCancel);
    var prim = {
      onDragStart: prim_onDragStart,
      onDragOver: prim_onDragOver,
      onDragEnd: prim_onDragEnd,
      onDragCancel: prim_onDragCancel
    };
    DndKit.wrappedUseDndMonitor(prim);
  };
  var convertContext = function ($$event) {
    return {
            active: Belt_Option.map(Caml_option.nullable_to_opt($$event.active), (function (over) {
                    return over.data.current.t;
                  })),
            over: Belt_Option.map(Caml_option.nullable_to_opt($$event.over), (function (over) {
                    return over.data.current.t;
                  }))
          };
  };
  var useDndContext$1 = function (param) {
    return convertContext(DndKit.wrappedUseDndContext());
  };
  var DndKit$Make$Provider = function (props) {
    return React.createElement(make, {
                onDragStart: makeStartCallback(props.onDragStart),
                onDragOver: makeEventCallback(props.onDragOver),
                onDragEnd: makeEventCallback(props.onDragEnd),
                onDragCancel: makeEventCallback(props.onDragCancel),
                children: props.children
              });
  };
  var Provider$1 = {
    make: DndKit$Make$Provider
  };
  var make$1 = DndKit.WrappedSortableContext;
  var SortableContext = {
    make: make$1
  };
  var make$2 = DndKit.WrappedDragOverlay;
  var DragOverlay = {
    make: make$2
  };
  var make$3 = DndKit.SortableItem;
  var SortableItem = {
    make: make$3
  };
  var make$4 = DndKit.DraggableItem;
  var DraggableItem = {
    make: make$4
  };
  var make$5 = DndKit.Droppable;
  var Droppable = {
    make: make$5
  };
  var make$6 = DndKit.SortHandle;
  var SortHandle = {
    make: make$6
  };
  var make$7 = DndKit.DragHandle;
  var DragHandle = {
    make: make$7
  };
  return {
          Js_Private: Js_Private,
          convertActiveEvent: convertActiveEvent,
          convertOverEvent: convertOverEvent,
          convertStartDragEvent: convertStartDragEvent,
          convertDragEvent: convertDragEvent,
          makeEventCallback: makeEventCallback,
          makeStartCallback: makeStartCallback,
          useDndMonitor: useDndMonitor$1,
          convertContext: convertContext,
          useDndContext: useDndContext$1,
          Provider: Provider$1,
          SortableContext: SortableContext,
          DragOverlay: DragOverlay,
          SortableItem: SortableItem,
          DraggableItem: DraggableItem,
          Droppable: Droppable,
          SortHandle: SortHandle,
          DragHandle: DragHandle
        };
}

export {
  arrayMove ,
  Make ,
}
/* react Not a pure module */
